// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__39tew","letter":"Loading_letter__3oydX","animationletter":"Loading_animationletter__vXjAo"};